import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ToastrType } from '../types/ToastrType.enum';

@Injectable({
  providedIn: 'root',
})
export class ToastrNotificationService {
  constructor(private toastr: ToastrService) {}

  showMessage(type: ToastrType, message: string, title: string = ''): void {
    const config = {
      timeOut: type === 'error' ? 10000 : 5000,
      closeButton: true,
      positionClass: 'toast-top-center',
      preventDuplicates: true,
    };

    switch (type) {
      case ToastrType.Success:
        this.toastr.success(message, title || 'Success', config);
        break;
      case ToastrType.Error:
        this.toastr.error(message, title || 'Error', config);
        break;
      case ToastrType.Warning:
        this.toastr.warning(message, title || 'Warning', config);
        break;
      case ToastrType.Info:
        this.toastr.info(message, title || 'Info', config);
        break;
    }
  }
}
